import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const TemplateCard = ({ template, onPreview }) => {
  const categoryColors = {
    system: 'bg-blue-100 text-blue-700',
    transactional: 'bg-purple-100 text-purple-700',
    marketing: 'bg-orange-100 text-orange-700'
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all group">
      {/* Template Type Badge */}
      {template.isSupabaseTemplate && (
        <div className="flex items-center gap-1.5 mb-3">
          <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-700 flex items-center gap-1">
            <SafeIcon name="Shield" className="text-xs" />
            Supabase Auth
          </span>
          {template.supabaseSlot && (
            <span className="text-xs font-medium px-2 py-1 rounded-full bg-emerald-50 text-emerald-600">
              → {template.supabaseSlot}
            </span>
          )}
        </div>
      )}
      {template.isAppTemplate && (
        <div className="flex items-center gap-1.5 mb-3">
          <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-violet-100 text-violet-700 flex items-center gap-1">
            <SafeIcon name="Zap" className="text-xs" />
            Emailit API
          </span>
        </div>
      )}

      <div className="flex items-start justify-between mb-3">
        <div className="text-3xl">{template.icon}</div>
        <span className={`text-xs font-bold px-3 py-1 rounded-full ${categoryColors[template.category] || 'bg-gray-100 text-gray-600'}`}>
          {template.category}
        </span>
      </div>

      <h3 className="font-bold text-gray-800 text-lg mb-1">{template.name}</h3>
      <code className="text-xs text-gray-400 font-mono bg-gray-50 px-2 py-1 rounded block mb-3">{template.slug}</code>
      <p className="text-sm text-gray-500 mb-4 line-clamp-2">{template.description}</p>

      {template.variables?.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-5">
          {template.variables.map((v) => (
            <span
              key={v}
              className={`text-xs px-2 py-1 rounded-md font-mono ${
                template.isSupabaseTemplate
                  ? 'bg-emerald-50 text-emerald-600'
                  : 'bg-pink-50 text-pink-600'
              }`}
            >
              {v}
            </span>
          ))}
        </div>
      )}

      <div className="flex gap-2 pt-4 border-t border-gray-100">
        <button
          onClick={() => onPreview(template)}
          className="flex-1 text-sm text-pink-600 hover:text-pink-800 font-semibold py-2.5 rounded-lg hover:bg-pink-50 transition-colors flex items-center justify-center gap-1.5"
        >
          <SafeIcon name="Eye" className="text-sm" />
          Preview & Copy
        </button>
      </div>
    </div>
  );
};

export default TemplateCard;